import { ofType } from 'redux-observable';
import { Observable as Obs } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, areaAddedAction } from '../../reducers/actions';
import { AreaService, FileService, IndoorMappingService } from '../../services';
import { BOUND_COORDINATES, LOCATION_TYPES } from '../../constants/areas';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.ADD_AREA),
    switchMap(action => {
      let isIndoor = action.area.location === LOCATION_TYPES.INDOOR;
      return forkJoin(
        of(action.area),
        isIndoor ? FileService.create(action.area.file[0], store) : of(null)
      ).pipe(
        switchMap(([area, file]) => {
          let corners = of(null);
          if (isIndoor) {
            area.file = file;
            corners = Obs.create(observer => {
              let i = new Image();
              i.onload = () => {
                let ratio = i.height / i.width;
                let height =
                  (BOUND_COORDINATES.EAST - BOUND_COORDINATES.WEST) * ratio;
                let south = BOUND_COORDINATES.NORTH - height;
                let nwCorner = {
                  lat: BOUND_COORDINATES.WEST,
                  lng: BOUND_COORDINATES.NORTH
                };
                let seCorner = {
                  lat: BOUND_COORDINATES.EAST,
                  lng: south
                };
                observer.next({ nwCorner, seCorner });
                observer.complete();
              };
              i.src = file.preview;
            });
          }
          return forkJoin(of(area), of(file), corners);
        }),
        switchMap(([area, file, corners]) =>
          forkJoin(
            of(area),
            isIndoor
              ? IndoorMappingService.create(
                  {
                    name: area.name,
                    account: area.account,
                    site: area.site,
                    file,
                    ...corners
                  },
                  store
                )
              : of(null)
          )
        ),
        switchMap(([area, indoorMapping]) => {
          area.indoorMapping = indoorMapping;
          return AreaService.create(area, store);
        }),
        map(area => areaAddedAction(area)),
        catchError(retryAuthentication(action$, 'epics/areas/areaAdd'))
      );
    })
  );
}



// WEBPACK FOOTER //
// ./src/epics/areas/areaAdd.js